import React, { useState, useEffect } from 'react';
import TypingAnimation from './TypingAnimation';

const CoordinatedTyping = ({ summaryPoints, speed = 25, initialDelay = 1000 }) => {
  const [activeIndex, setActiveIndex] = useState(-1);
  const [completedPoints, setCompletedPoints] = useState(new Set());

  useEffect(() => {
    if (!summaryPoints || summaryPoints.length === 0) return;

    const startTimer = setTimeout(() => {
      setActiveIndex(0);
    }, initialDelay);

    return () => clearTimeout(startTimer);
  }, [summaryPoints, initialDelay]);

  const handlePointComplete = (index) => {
    setCompletedPoints(prev => new Set([...prev, index]));
    
    if (index < summaryPoints.length - 1) {
      setTimeout(() => {
        setActiveIndex(index + 1);
      }, 300);
    }
  };

  if (!summaryPoints || summaryPoints.length === 0) return null;

  return (
    <div className="space-y-2">
      {summaryPoints.map((point, index) => (
        <div key={index} className="text-sm text-slate-700 flex items-start">
          <div className="w-1.5 h-1.5 bg-slate-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
          <div className="leading-relaxed flex-1">
            {index < activeIndex ? (
              <div className="prose prose-sm max-w-none text-slate-700">
                {point}
              </div>
            ) : index === activeIndex ? (
              <TypingAnimation 
                text={point} 
                speed={speed}
                startDelay={0}
                showCursor={true}
                onComplete={() => handlePointComplete(index)}
              />
            ) : (
              <div className="h-5 opacity-0"></div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default CoordinatedTyping;
